// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const SleepOutline = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 96 96" {...props}>
		<path
			d="M14.266 63.662C20.466 75.677 33.048 83.5 46.76 83.5c20.144 0 36.531-16.388 36.531-36.532a36.525 36.525 0 0 0-20.903-33.02 40.393 40.393 0 0 1 1.292 10.167c0 22.35-18.183 40.532-40.532 40.532-2.997 0-5.969-.33-8.88-.985M46.758 87.5c-16.756 0-31.995-10.532-37.92-26.21a2 2 0 0 1 2.516-2.6 36.464 36.464 0 0 0 11.792 1.957c20.144 0 36.532-16.388 36.532-36.532 0-4.432-.792-8.775-2.354-12.908a2 2 0 0 1 2.516-2.6 40.523 40.523 0 0 1 27.45 38.36c0 22.35-18.183 40.533-40.532 40.533"
			fillRule="evenodd"
		/>
	</svg>
);
export default SleepOutline;
